import { EnvironmentVariables } from './environment-variables'
import * as pkg from '../../../../package.json'

export const environment: EnvironmentVariables = {
  production: true,
  tokenLocalStorageKey: 'token',
  routeTracing: false,
  workflowHost: 'https://api-internal-wdf.gpei.ca/api',
  preventInitialLoad: false,
  validator: null,
  defaultService: null,
  saveLocation: null,
  serviceId: null,
  durationBeforeSessionExpiringWarning: 900000,
  deployUrl: 'https://wdf.princeedwardisland.ca/js/',
  version: pkg?.version,
  customElementAdoptStyleSheets: true
}
